// extracted by mini-css-extract-plugin
module.exports = {"container":"Fq","discount":"Gq","price":"Hq","sale":"Iq","originalPrice":"Jq","msrp":"Kq","percentOff":"Lq","percentOffBanner":"Mq"};